// google map initialization
var marker;
var map;
var mapStyles = [ {"featureType":"road","elementType":"geometry.fill","stylers":[{"saturation":-9},{"lightness":42}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"saturation":-31},{"lightness":39}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#abd6ed"},{"lightness":7}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"lightness":29}]},{"featureType":"landscape.man_made","elementType":"all","stylers":[{"saturation":-9},{"lightness":38}]},{"featureType":"road.highway","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"off"}]} ];

function initialize(location) {
  var mapOptions = {
    zoom: 15,
    center: location,
    disableDefaultUI: false,
    streetViewControl: false,
    scrollwheel: false,
    styles: mapStyles,
    panControl: false,
    zoomControl: true
  };

  map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);

  marker = new google.maps.Marker({
    map:map,
    draggable:true,
    animation: google.maps.Animation.DROP,
    position: location
  });

  google.maps.event.addListener(marker, 'dragend', setLangLat);
}

function setLangLat() {
  $('#location_latitude').val(marker.getPosition().lat());
  $('#location_longitude').val(marker.getPosition().lng());
}

// This is used to search the address and pin the searched location.
// used for projects in Guru and User side
$(document).ready(function() {
  $('#pin-project-location').show();
  $('#locationpicker-map-canvas').locationpicker('autosize');

  function updateControls(addressComponents) {
    $('#location_attributes_district').val(addressComponents.district);
    $('#location_attributes_city_name').val(addressComponents.city);
    $('#location_attributes_state_name').val(addressComponents.stateOrProvince);

    country = (addressComponents.country == 'United Arab Emirates' ? 'UAE' : addressComponents.country)

    $('#location_attributes_country_name').val(country);
  }

  if($('#locationpicker-map-canvas').length > 0 ) {
    $('#locationpicker-map-canvas').locationpicker({
      location: { latitude: $('#location_attributes_latitude').val(), longitude: $('#location_attributes_longitude').val() },
      radius: 0,
      onchanged: function (currentLocation, radius, isMarkerDropped) {
              var addressComponents = $(this).locationpicker('map').location.addressComponents;
              updateControls(addressComponents);
          },
      oninitialized: function(component) {
          var addressComponents = $(component).locationpicker('map').location.addressComponents;
          updateControls(addressComponents);
      },
      inputBinding: {
      latitudeInput: $('#location_attributes_latitude'),
      longitudeInput: $('#location_attributes_longitude'),
      locationNameInput: $('#address')
      },
      enableAutocomplete: true
      });
    }

  if($('#location_attributes_longitude').length > 0){
    $("#address").keypress(function(e) {
      if (e.which == 13) {
        return false;
      }
    });
  }
});
